import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export const RUN_NOW_ICON = $icon('player-play');
export function getPauseOrResumeIcon(type) {
    if (type === 'resume')
        return $icon('custom-play-circle');
    return $icon('player-pause');
}
//# sourceMappingURL=scheduledTaskActionIcons.js.map